import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const CopyIcon = (props: SvgIconProps) => <ContentCopyIcon {...props} />;
export default CopyIcon;
